// extracted by mini-css-extract-plugin
module.exports = {"change-request":"ChangeRequest_change-request__1abW_"};